<template>
  <div style="padding-right: 24px">
    <el-form ref="formRef" :model="taskForm" label-width="130px">
      <el-form-item label="任务名称：">
        <el-input type="text" v-model="taskForm.name" placeholder="输入任务名称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="任务描述：">
        <el-input type="text" v-model="taskForm.description" placeholder="输入任务描述" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="奖励金币：">
        <el-input type="text" v-model="taskForm.rewardGoldNum" placeholder="请输入正整数" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="每日可完成次数：" v-if="everydayNumState">
        <el-input type="text" v-model="taskForm.everydayNum" placeholder="输入大于等于1的正整数" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="条件参数：" v-if="taskForm.edit == 1">
        <el-input type="text" :maxlength="3" v-model="taskForm.conditionNum" placeholder="请输入条件参数" style="width:24em"></el-input>
      </el-form-item>
      <el-form-item label="任务排序：">
        <el-input type="text" v-model="taskForm.showOrder" placeholder="排序，越大越靠前" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="置顶状态：">
        <el-radio-group v-model="taskForm.toTop">
          <el-radio :label="1">已置顶</el-radio>
          <el-radio :label="2">未置顶</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="任务状态：">
        <el-radio-group v-model="taskForm.state">
          <el-radio :label="1">开启中</el-radio>
          <el-radio :label="2">已下架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="展示版本：">
        <el-radio-group v-model="taskForm.versionState">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">旧版</el-radio>
          <el-radio :label="2">新版</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="sex" placeholder="Select" style="width: 10em" disabled>
          <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateTaskCenterInfo } from "@/api/url";
import {greaterIntReg, positiveIntReg} from "@/assets/shared/reg-constant";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      taskForm: this.value.taskForm,
      idx: this.value.ids,
      loading: false,

      sexArray: [
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: this.value.taskForm.sex?this.value.taskForm.sex:0,
      everydayNumState: this.value.taskForm.everydayNum

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.taskForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '任务名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.taskForm.description) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '任务描述不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.taskForm.rewardGoldNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '奖励金币不能为空',
          type: 'warning'
        });
        return false
      } else if(!positiveIntReg.test(this.taskForm.rewardGoldNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "奖励为正整数",
          type: 'warning'
        });
        return false
      }
      if(!greaterIntReg.test(this.taskForm.everydayNum) && this.taskForm.type == 1) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "每日可完成次数为大于等于1的正整数",
          type: 'warning'
        });
        return false
      }
      if(this.taskForm.edit == 1 && !this.taskForm.conditionNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '条件参数不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.taskForm.showOrder) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '任务排序不能为空',
          type: 'warning'
        });
        return false
      } else if (!positiveIntReg.test(this.taskForm.showOrder)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "请检查排序是否为正整数",
          type: 'warning'
        });
      }
      this.loading = true
      let param = {};
      param['id'] = this.taskForm.id;
      param['name'] = this.taskForm.name;
      param['description'] = this.taskForm.description;
      param['rewardGoldNum'] = this.taskForm.rewardGoldNum;
      param['everydayNum'] = this.taskForm.everydayNum;
      param['showOrder'] = this.taskForm.showOrder;
      param['conditionNum'] = this.taskForm.conditionNum;
      param['toTop'] = this.taskForm.toTop;
      param['state'] = this.taskForm.state;
      param['versionState'] = this.taskForm.versionState;
      postFormData(updateTaskCenterInfo, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    console.log(this.everydayNumState)
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
